import React from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { usePaths } from '../hooks/usePaths';
import { useCustomBreadcrumb } from '../hooks/useCustomBreadcrumb';
import { getCamelCase } from '../utils/getters';

import Button from './Button';
import Icon from './Icon';

export default function Breadcrumb() {
  const { customCrumbs } = useCustomBreadcrumb();
  const { getPathObjectWithPathname } = usePaths();

  const CrumbLabel = ({ pageName }) =>
    pageName === 'home' ? (
      <Icon icon="MdHome" />
    ) : pageName ? (
      <Trans id={getCamelCase(pageName)} />
    ) : null;

  return (
    <>
      {customCrumbs.length > 1 && (
        <div className="breadcrumb">
          {customCrumbs?.map((crumb, i) => {
            const pageName = getPathObjectWithPathname(crumb.pathname)?.name;
            return (
              <React.Fragment key={`crumb-${i}`}>
                {pageName && (
                  <div className="breadcrumb__crumb" key={crumb?.key}>
                    <Button
                      isDisabled={i === customCrumbs.length - 1}
                      button={{
                        version: 'tertiary-text',
                        additionalClassNames: '--x-small',
                        ariaLabel: pageName,
                        label: <CrumbLabel pageName={pageName} />,
                        pathname: crumb?.pathname
                      }}
                    />
                    {i !== customCrumbs.length - 1 && (
                      <Icon icon="MdChevronRight" />
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </>
  );
}
